import script from "./Newelegant.vue?vue&type=script&setup=true&lang=js"
export * from "./Newelegant.vue?vue&type=script&setup=true&lang=js"

import "./Newelegant.vue?vue&type=style&index=0&id=26201d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26201d58"]])

export default __exports__